import { Booking } from './booking';
import { BookingAccount } from './booking-account';

export class BookingForm extends Booking {
  dueDate = 14;
  remainingBalanceEmailDate = 21;
}
